import React, { useEffect } from "react";
import Header from "./../components/Header";
import Footer from "./../components/Footer";
import { useLocation, Link } from "react-router-dom";
import CurrencyFormat from "../components/shared/CurrencyFormat";

const Payment = () => {
  const {
    state: { price, orderId },
  } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />
      <section className="bg-[#eeeeee]">
        <div className="w-[90%] md:w-[85%] mx-auto py-16 mt-4">
          <div className="flex justify-center">
            <div className="w-full max-w-2xl">
              <div className="bg-white shadow-sm p-8 rounded-lg text-center">
                <div className="flex justify-center mb-6">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                </div>

                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  ¡Pedido Confirmado!
                </h2>

                <p className="text-gray-600 mb-6">
                  Tu pedido #{orderId} ha sido procesado exitosamente
                </p>

                <div className="bg-gray-50 p-4 rounded-lg mb-6">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-600">Total a Pagar:</span>
                    <span className="text-xl font-bold text-green-600">
                      <CurrencyFormat value={price} />
                    </span>
                  </div>
                </div>

                <Link
                  to="/"
                  className="inline-block px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                >
                  Volver a la Tienda
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Payment;
